import MainPanelSubLayout from './MainPanelSubLayout';

export default MainPanelSubLayout;
